import { createSelector } from "reselect";
// eslint-disable-next-line @logicsoftware/ep-custom/no-cross-feature-imports
import { getShowPortfolios } from "~/app/selectors/common";
import { getClientIsGroupByPortfolioEnabled, getClientIsNestedPortfoliosEnabled } from "~/Redux/Customization";
import { getLicenseFlags } from "~/Redux/License/selectors";
import { LicenseFlagsBoolean } from "~/Redux/License/types";

export const getIsNestedPortfoliosEnabled = createSelector(
    getClientIsNestedPortfoliosEnabled,
    getLicenseFlags,
    (isNestedPortfoliosEnabled, licenseFlags) =>
        isNestedPortfoliosEnabled || !!licenseFlags?.[LicenseFlagsBoolean.portfoliosNested]
);

export const getIsGroupByPortfolioEnabled = createSelector(
    getClientIsGroupByPortfolioEnabled,
    getShowPortfolios,
    getLicenseFlags,
    (isGroupByPortfolioEnabled, showPortfolios, licenseFlags) =>
        showPortfolios && (isGroupByPortfolioEnabled ?? !!licenseFlags[LicenseFlagsBoolean.portfoliosGroupBy])
);
